// InstantMessagePartnersSettings - MODULE
// ***********************************************************************************************************************
import * as React from "react";
import { AppUtils } from "../../../framework/appUtils";
import { ICompanyListItem } from "../../../models/company/companyListItem";
import * as instantMessageService from "../../../models/services/instantMessageService";
import { InstantMessagePartnersDialogCompanyList } from "../InstantMessagePartnersDialogCompanyList";

//InstantMessagePartnersSettings
export interface IInstantMessagePartnersSettingsProp {
    companyId: string;
    onCancel: (instantMessagePartnersWasModified: boolean) => void;
}

export interface IInstantMessagePartnersSettingsState {
    isLoading: boolean;
    companies: ICompanyListItem[];
    instantMessagePartnersWasModified: boolean;
}

export class InstantMessagePartnersSettings extends React.Component<IInstantMessagePartnersSettingsProp, IInstantMessagePartnersSettingsState> {
    constructor(props: IInstantMessagePartnersSettingsProp) {
        super(props);
        this.state = {
            isLoading: false,
            companies: [],
            instantMessagePartnersWasModified: false
        };
    }

    loadInstantMessageChannel = async () => {
        const props = this.props;
        this.setState({ isLoading: true });
        const result = await AppUtils.callService(() => instantMessageService.getInstantMessagePartners(props.companyId), false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        const state = {
            ...this.state,
            companies: result.items
        };
        this.setState(state);
    };

    componentDidMount(): void {
        this.loadInstantMessageChannel();
    }

    // #region Partner Companies
    handleCompaniesRemoved = (ids: string[]) => {
        if (!ids || ids.length < 1) return;
        this.setState({
            companies: this.state.companies.filter(i => ids.indexOf(i.id) < 0),
            instantMessagePartnersWasModified: true
        });
    };
    
    handleCompaniesAdded = (newCompanies: ICompanyListItem[]) => {
        const state = this.state;
        this.setState({
            companies: state.companies.filter(i => newCompanies.findIndex(j => j.id === i.id) < 0).concat(newCompanies),
            instantMessagePartnersWasModified: true
        });
    };
    // #endregion Partner Companies

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        props.onCancel(state.instantMessagePartnersWasModified);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <InstantMessagePartnersDialogCompanyList
                companyId={props.companyId}
                companies={state.companies}
                onRemoved={this.handleCompaniesRemoved}
                onAdded={this.handleCompaniesAdded}
            />
        );
    }
}